<template>
  <div class="wrap">
    <div v-if="detail" class="formInfo">
      <template v-for="item in detail.Titles">
        <div v-if="ignoreKeys.indexOf(item.key) == -1" class="formItem" :key="item.key">
          <div class="label">{{ item.label }}：</div>
          <div class="value" v-if="item.tag=='el-upload'&&detailData[item.key]">
            <template v-for="(up,upIndex) in JSON.parse(detailData[item.key])">
              <el-image v-if="up.type.indexOf('image')>-1" :src="up.realsrc" :preview-src-list="[up.realsrc]"
                        alt="" :key="'img_'+upIndex" class="value-img"></el-image>
              <div v-else-if="up.type.indexOf('audio')>-1" :key="'audio_'+upIndex">
                <audio :src="up.realsrc" alt=""
                       controls></audio>
              </div>
              <div v-else-if="up.type.indexOf('video')>-1" :key="'video_'+upIndex">
                <video :src="up.realsrc" alt="" controls></video>
              </div>
              <div v-else :key="'file_'+upIndex">
                <a :href="up.realsrc" :download="up.name">{{ up.name }}</a>
              </div>
            </template>
          </div>
          <div v-else class="value">{{ detailData[item.key] }}</div>
        </div>
      </template>
      <div v-if="detail.ApproveTeacherList" class="formItem" style="align-items: center">
        <div class="label">审批人 ：</div>
        <div class="value">{{ detail.ApproveTeacherList.join(',') }}</div>
      </div>
      <template v-if="detail.CanApprove == 1">
        <div class="formItem" style="align-items: center">
          <div class="label">审批意见：</div>
          <van-radio-group v-if="detail.CanApprove == 1" v-model="sp.status" direction="horizontal">
            <van-radio :name="1">同意</van-radio>
            <van-radio :name="2">驳回</van-radio>
          </van-radio-group>
        </div>
        <div v-if="sp.status == 2" class="formItem">
          <div class="label">驳回原因：</div>
          <van-field v-model="sp.note" type="textarea" rows="3" autosize placeholder="请输入驳回原因"
                     style="border: 1px solid #ddd"/>
        </div>
      </template>
    </div>
    <div class="btns" slot="footer" align="center">
      <van-button @click="$router.back()" class="btn">返回</van-button>
      <van-button @click="approvev2" v-if="detail.CanApprove == 1" type="primary" class="btn">审批</van-button>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";

export default {
  name: "detail",
  data() {
    return {
      detail: {},
      detailData: {},
      ignoreKeys: ['id'],
      sp: {
        status: '',
        note: '',
      },
    }
  },
  mounted() {
    this.getDetailV2()
  },
  methods: {
    getDetailV2() {
      let self = this;
      let {id, formKey} = this.$route.query
      this.whale.remote.getResult({
        url: "/api/api/flow-form-data/v2/detail?id=" + id + "&FormKey=" + formKey,
        completed: function ({ResultType, Message, AppendData}) {
          if (ResultType == 0) {
            self.detail = AppendData
            self.detailData = AppendData.data
            console.log(self.detail)
          } else {
            self.whale.toast.err(Message)
          }
        }
      })
    },
    approvev2() {
      let self = this
      if (self.sp.status == 2 && self.sp.note == '') {
        Toast.fail('请选择审批意见')
        return
      }
      let {formKey, id} = self.$route.query
      this.whale.remote.getResult({
        url: "/api/api/flow-form-data/approvev2",
        data: {formKey: formKey, id: id, ...self.sp},
        completed: function () {
          Toast.success('审批成功')
          self.$router.go(-1)
        }
      })
    }
  }
}
</script>

<style scoped>
.wrap {
  background: #fff;
  padding: 20px;
}

.formInfo .formItem {
  padding: 4px 0;
  display: flex;
}

.formInfo .formItem .label {
  flex: 0 0 auto;
}

.btns {
  margin-top: 40px;
}

.btns .btn {
  margin: 5px 20px;
}
</style>